export default __webpack_public_path__ + "static/media/01_12_2021-30_nov._119_jab_2021.69172d74.jpg";